import React from 'react';
import VisitorDashboard from './VisitorDashboard';
import { AppBar, Toolbar, Typography, IconButton, Box, Button, Tooltip } from '@mui/material';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import Brightness5Icon from '@mui/icons-material/Brightness5';
import NightsStayIcon from '@mui/icons-material/NightsStay';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';

const MainVisitorDashboard = () => {
  const navigate = useNavigate();

  const now = new Date();
  const hour = now.getHours();
  const time = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  const date = now.toLocaleDateString('en-GB', {
    weekday: 'short',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });

  // Determine greeting and icon based on hour
  let greeting = '';
  let GreetingIcon = WbSunnyIcon;
  if (hour >= 5 && hour < 12) {
    greeting = 'Good Morning';
    GreetingIcon = WbSunnyIcon;
  } else if (hour >= 12 && hour < 17) {
    greeting = 'Good Afternoon';
    GreetingIcon = Brightness5Icon;
  } else {
    greeting = 'Good Evening';
    GreetingIcon = NightsStayIcon;
  }

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/");
  }

  return (
    <>
      {/* Header */}
      <AppBar position="static" style={{ backgroundColor: '#3b5273', padding: '0 1rem' }}>
        <Toolbar style={{ display: 'flex', justifyContent: 'space-between', minHeight: '48px' }}>
          {/* Left: Greeting */}
          <Box display="flex" alignItems="center">
            <GreetingIcon style={{ color: '#fbbf24', marginRight: 6 }} />
            <Typography variant="body1">{greeting}</Typography>
          </Box>

          {/* Center: Title */}
          <Typography variant="h6" style={{ fontWeight: 'bold', textAlign: 'center' }}>
            GSV Central Library (CSJMU)
          </Typography>

          {/* Right: Time + Date + Logout */}
          <Box display="flex" alignItems="center" gap={2}>
            <Box textAlign="right">
              <Typography variant="body1" style={{ fontWeight: 'bold' }}>{time}</Typography>
              <Typography variant="caption">{date}</Typography>
            </Box>
            <Tooltip title="Logout">
              <IconButton
                onClick={handleLogout}
                style={{
                  backgroundColor: '#e68a3c',
                  color: 'white',
                  borderRadius: '50%',
                  width: '40px',
                  height: '40px',
                }}
              >
                <LogoutIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Main Dashboard */}
      <VisitorDashboard />
    </>
  );
};

export default MainVisitorDashboard;
